import { FormData } from '../../pages/incidents/Incidents'
import { BASE_URL } from '../endpoints'
import { del, get, patch, post } from '../https'

export interface actionData {
  detail: string
  mentions: string[]
}
export const getAllIncidents = (
  sortBy: string,
  sortOrderValue: string
): Promise<unknown> => {
  return get(
    `${BASE_URL}/incidents?sortBy=${sortBy}&sortOrder=${sortOrderValue}`
  )
}

export const getAllIncidentsLead = (
  sortBy: string,
  sortOrderValue: string,
  siverity: string
): Promise<unknown> => {
  return get(
    `${BASE_URL}/incidents?sortBy=${sortBy}&sortOrder=${sortOrderValue}&search=${siverity}&searchBy=severity_level`
  )
}

export const getAllIncidentsInvitedUsers = (id: string): Promise<unknown> => {
  return get(`${BASE_URL}/incidents/${id}/invitations`)
}

export const getIncidentById = (id: string, sId: string): Promise<unknown> => {
  return get(`${BASE_URL}/incidents/${id}?school=${sId}`)
}
export const createIncident = (data: FormData): Promise<unknown> => {
  return post(`${BASE_URL}/incidents`, data, null)
}

export const updateIncident = (
  data: FormData,
  id: string
): Promise<unknown> => {
  return patch(`${BASE_URL}/incidents/${id}`, data, null)
}

export const updateIncidentStatus = (
  data: {
    status: string
  },
  id: string
): Promise<unknown> => {
  return patch(`${BASE_URL}/incidents/${id}/change-status`, data, null)
}

export const deleteIncident = ({
  id,
}: {
  id: string | undefined
}): Promise<unknown> => {
  return del(`${BASE_URL}/incidents/${id}`, null)
}

export const getAllSchoolMembers = (): Promise<unknown> => {
  return get(`${BASE_URL}/school-members/admins`)
}

export const createIncidentInvitation = (
  data: {
    userId: string
    viewAccess: boolean
    editAccess: boolean
    deleteAccess: boolean
  },
  id: string
): Promise<unknown> => {
  return post(`${BASE_URL}/incidents/${id}/invitations`, data, null)
}

export const deleteIncidentInvitation = ({
  id,
}: {
  id: string | undefined
}): Promise<unknown> => {
  return del(`${BASE_URL}/incidents/invitations/${id}`, null)
}

export const getNotes = (id: string): Promise<unknown> => {
  return get(`${BASE_URL}/incidents/${id}/notes`)
}

export const getNotesUsers = (id: string): Promise<unknown> => {
  return get(`${BASE_URL}/incidents/${id}/involved-users`)
}

export const createNotes = (data: actionData, id: string): Promise<unknown> => {
  return post(`${BASE_URL}/incidents/${id}/notes`, data, null)
}
